/**
 * Organizer EMS feature-access response models.
 *
 * These are factories because each API response must receive a fresh object.
 */
export const organizerFeatureAccessFeatureModel = () => ({
	'funcid': '', // 功能識別碼
	'enabled': false, // 是否已開通
});

export const organizerFeatureAccessMenuResponseModel = () => ({
	'status': 'NG', // 回應狀態
	'program': 'organizer-ems', // 功能授權程式
	'features': [], // 功能目錄與開通狀態
});

export const organizerFeatureAccessCheckResponseModel = () => ({
	'status': 'NG', // 回應狀態
	'program': 'organizer-ems', // 功能授權程式
	'funcid': '', // 被檢查的功能識別碼
	'enabled': false, // 是否已開通
	'code': '', // 錯誤代碼（例如 FEATURE_NOT_ENABLED）
});
